import React from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { resendVerificationLogin } from "../../redux/slices/authSlice";
import { Button } from "antd";
const EmailNotVerified = () => {
  const dispatch = useDispatch();
  const [mailResent, setMailResent] = React.useState(false);
  const handleResend = async () => {
    const email = localStorage.getItem("loginEmail");
    const password = localStorage.getItem("loginPassword");

    if (email && password) {
      await dispatch(resendVerificationLogin({ email, password }));
      setMailResent(true);
    }
  };

  return (
    <div
      style={{
        backgroundColor: "#fff",
        borderRadius: "16px",
        padding: "30px 24px",
        maxWidth: "600px",
        width: "100%",
        textAlign: "center",
        fontFamily: "Arial, sans-serif",
        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)",
        gap: `${mailResent}` ? "0px" : "10px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
       
    >
      {mailResent ? (
        <h2
          style={{
            color: "#28a745",
            fontSize: "20px",
            fontWeight: "bold",
            marginBottom: "20px",
            lineHeight: "1.4",
          }}
        >
          Verification email has been resent. 
          <br/>
          Please check your inbox.
        </h2>
      ) : (
        <div>
          <h2
            style={{
              color: "red",
              fontSize: "20px",
              fontWeight: "bold",
              marginBottom: "20px",
              lineHeight: "1.4",
            }}
          >
            You are unable to log in because your
            <br />
            email address
            <br />
            has not been verified yet
          </h2>

          <p
            style={{
              fontSize: "16px",
              color: "#000",
              marginBottom: "12px",
              lineHeight: "1.5",
            }}
          >
            Click{" "}
            <Button
              type="link"
              onClick={handleResend}
              style={{
                color: "#007aff",
                textDecoration: "none",
                fontWeight: "500",
                padding: "0",
              }}
            >
              Resend Verification Email
            </Button>{" "}
            to receive the
            <br /> link on your registered email address.
            <br />
            Once you verify your email, you can proceed
            <br /> to log in as usual.
          </p>
        </div>
      )}
      
      <p
        style={{
          fontSize: "14px",
          color: "#444",
          fontStyle: "italic",
          marginTop: "25px",
        }}
      >
        For any issues, please contact{" "}
        <a
          href="mailto:abhishek.sharma@zucol.in
"
          style={{ color: "#000", textDecoration: "none" }}
        >
          abhishek.sharma@zucol.in
        </a>
      </p>
    </div>
  );
};

export default EmailNotVerified;
